import { BudgetMissionInput } from '../../lib/types/models/mission/mission-input'
import { MissionToStaffParam } from '../../lib/types/models/mission-to-staff/mission-to-staff-param'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function assignHotelToStaff(input: MissionToStaffParam) {
  const { id, staffId } = input
  return restApiClient
    .url(constructApiUrl(API.missions.assignHotelToStaff.url, { id, staffId }))
    .patch()
}

export function unassignHotelToStaff(input: MissionToStaffParam) {
  const { id, staffId } = input
  return restApiClient
    .url(constructApiUrl(API.missions.unassignHotelToStaff.url, { id, staffId }))
    .patch()
}

export function assignTicketToStaff(input: MissionToStaffParam) {
  const { id, staffId } = input
  return restApiClient
    .url(constructApiUrl(API.missions.assignTicketToStaff.url, { id, staffId }))
    .patch()
}

export function unassignTicketToStaff(input: MissionToStaffParam) {
  const { id, staffId } = input
  return restApiClient
    .url(constructApiUrl(API.missions.unassignTicketToStaff.url, { id, staffId }))
    .patch()
}

export function includeBudgetToStaff(input: MissionToStaffParam) {
  const { id, staffId } = input
  return restApiClient
    .url(constructApiUrl(API.missions.includeBudgetToStaff.url, { id, staffId }))
    .patch()
}

export function excludeBudgetToStaff(input: MissionToStaffParam) {
  const { id, staffId } = input
  return restApiClient
    .url(constructApiUrl(API.missions.excludeBudgetToStaff.url, { id, staffId }))
    .patch()
}

export function updateBudgetToStaff(input: BudgetMissionInput & MissionToStaffParam) {
  const { id, staffId, ...rest } = input
  return restApiClient
    .url(constructApiUrl(API.missions.updateBudgetToStaff.url, { id, staffId }))
    .patch<never, BudgetMissionInput>(rest)
}
